export default "__VITE_ASSET__C4NzS69I__"